export default __webpack_public_path__ + "187ef82d6dd5a2d1e6753eb32659ad20.svg";